module.exports = __webpack_public_path__ + "img/book.b2bde3c3.svg";